import { Deserializable } from "../shared/models/deserializable.model";

import { Business } from "../models/business";

import { Decimal } from 'decimal.js';

export class WorkItem implements Deserializable {
   id: number;
   name: string;
   description: string;
   rate: number;
   quantity: number;
   taxRate: number = 0; // Default value set to 0
   hasTax: boolean = false; // Default value set to false
   invoiceId: number;
   quoteId: number;
   total: number;
   subtotal: number;
   order: number;

   deserialize(input: any) {
   	Object.assign(this, input);
      
      // Ensure hasTax and taxRate have default values if they are not provided
      this.hasTax = input.hasTax !== undefined ? input.hasTax : false;
      this.taxRate = input.taxRate !== undefined ? input.taxRate : 0;

      return this;
  }

  getDisplayRate() {
     return this.rate / 100;
  }

  getDisplayedSubTotal() {
     return this.subtotal / 100;
  }

  getDisplayedTotal() {
     return this.total / 100;
  }

  get getTotal(): any {

   var total = 0;
   var totalTax = 0;
   var totalIncTax = 0;
   
   var subTotal = this.quantity * this.rate*0.01;
   var subTax = subTotal * (this.taxRate/100);

   // Add to running total
   total += subTotal;

   if (this.hasTax) {
      totalTax += subTax;
      totalIncTax += subTotal + subTax;
   }
   else {
      totalIncTax += subTotal;
   }


   return {
      total: total.toFixed(2),
      totalTax: totalTax.toFixed(2),
      totalIncTax: totalIncTax.toFixed(2),
   }
 }

   totalPreview(rate: number, qty: number, hasTax: boolean, taxRate: number) {
     if (rate && qty) {
        rate = rate / 100;
        const decimalRate = new Decimal(rate);
        const decimalQty = new Decimal(qty);
        const decimalTaxRate = new Decimal(taxRate/100);

        if (hasTax) {
          const taxAmount = decimalRate.times(decimalQty).times(decimalTaxRate);
          return decimalRate.times(decimalQty).plus(taxAmount).toFixed(2);
        } else {
          return decimalRate.times(decimalQty).toFixed(2);
        }
     }
     else {
        return 0.00;
     }
   }

   subTotalPreview(rate: number, qty: number) {
     if (rate && qty) {

        rate = rate / 100;
        const decimalRate = new Decimal(rate);
        const decimalQty = new Decimal(qty);

        return decimalRate.times(decimalQty).toFixed(2);

     }
     else {
        return 0.00;
     }
   }

}